import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GeneralComponent } from './general.component';
import {SharedModule} from '../../shared/shared.module';
import {UIModule} from '../ui/ui.module';

@NgModule({
  imports: [
    CommonModule,
      SharedModule,
      UIModule
  ],
  declarations: [
      GeneralComponent
  ]
})
export class GeneralModule { }
